import PropTypes from "prop-types";
import { BreadcrumbItem, NavLink as ReactStrapNavLink } from "reactstrap";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const StyledNavLink = styled(ReactStrapNavLink)`
  color: #0078a8;
  &:hover {
    color: #0078a8;
  }
  padding: 0 !important;
  text-align: left;
  display: inline-flex;
`;

const StyledBreadcrumbItem = styled(BreadcrumbItem)`
  &::before {
    color: #0078a8 !important;
  }
`;
const Link = ({ children, to, external }) => {
  const tag = external ? "a" : NavLink;
  const tagProps = external ? { href: to } : { to };
  const target = external ? "_blank" : "";

  return (
    <StyledBreadcrumbItem>
      <StyledNavLink {...tagProps} tag={tag} target={target}>
        {children}
      </StyledNavLink>
    </StyledBreadcrumbItem>
  );
};

Link.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  external: PropTypes.bool,
};

Link.defaultProps = {
  to: "#",
  external: false,
};

export default Link;
